const limitExceededCardStyle = (theme) => ({
	card: {
		backgroundColor: '#FEECF4',
	},
	itemsToChangeWrapper: {
		display: 'flex',
		paddingTop: 16,
		alignItems: 'center',
		justifyContent: 'flex-start',
		flexWrap: 'wrap',
		[theme.breakpoints.down('xs')]: {
			flexDirection: 'column',
			alignItems: 'flex-start',
			'& > p': {
				marginBottom: 10,
			},
		},
		'& > p': {
			marginRight: 24,
		},
	},
	cardBody: {
		padding: 12,
	},
	button: {
		marginBottom: 0,
		[theme.breakpoints.down('xs')]: {
			paddingLeft: 0,
			marginTop: 0,
		},
	},
});

export default limitExceededCardStyle;
